export default __webpack_public_path__ + "static/media/crane.e5f54bf3.svg";